import React from "react";

export default function PageNotFound() {
    return (
        <div>
            <h2>404 Page not found</h2>
        </div>
    )
        
}